var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclude(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 2.60317C1.33333 1.89841 1.89841 1.33333 2.60317 1.33333H9.5873C10.2921 1.33333 10.8571 1.89841 10.8571 2.60317V5.14285H13.3968C14.1016 5.14285 14.6667 5.70793 14.6667 6.41269V13.3968C14.6667 14.1016 14.1016 14.6667 13.3968 14.6667H6.4127C5.70794 14.6667 5.14286 14.1016 5.14286 13.3968V10.8571H2.60317C1.89841 10.8571 1.33333 10.2921 1.33333 9.5873V2.60317ZM10.6667 5.33333H5.33333V10.6667H10.6667V5.33333Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclude);
export default __webpack_public_path__ + "static/media/Exclude.49164cf3b4654dc7772d8dfd33d7d423.svg";
export { ForwardRef as ReactComponent };